import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Container,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import Swal from "sweetalert2";

const FormularioPrincipal = () => {
  const [nombre, setNombre] = useState("");
  const [titulo, setTitulo] = useState("");
  const [estado, setEstado] = useState(0);
  const [lineaServicio, setLineaServicio] = useState("");
  const [canal, setCanal] = useState("");

  const lineasDeServicio = [
    { value: "300000058635046", label: "Corporativo" },
    { value: "300000058635173", label: "Licitaciones" },
    { value: "300000058635222", label: "Seguimiento" },
    { value: "300000058634831", label: "Linea Abierta" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nuevoFormulario = {
      descripcion: nombre,
      titulo: titulo,
      estado: "0",
      publicacion: "",
      lineaServicio: lineaServicio,
      canal: canal,
    };

    try {
      const response = await axios.post(
        "https://portaltransaccionalback.azurewebsites.net/api/PostPrincipal",
        nuevoFormulario
      );

      Swal.fire({
        icon: "success",
        title: "¡Formulario creado!",
        text: "El formulario ha sido creado con éxito.",
        confirmButtonText: "Continuar",
      }).then(() => {
        window.location.href = "/SubeImagen/" + response.data;
      });

      setNombre("");
      setTitulo("");
      setEstado(0);
      setLineaServicio(""); // Limpia la línea de servicio
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al crear el formulario. Inténtalo de nuevo.",
      });

      console.error("Error en la solicitud:", error);
    }
  };

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div
            className="card shadow mb-4"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "50%",
              height: "auto",
              margin: "0 auto",
            }}
          >
            <div className="card-header py-3">
              <Container maxWidth="sm" style={{ marginTop: "20px" }}>
                <Typography variant="h4" align="center" gutterBottom>
                  Crear Formulario Principal
                </Typography>
                <form
                  onSubmit={handleSubmit}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <TextField
                    label="Título"
                    variant="outlined"
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    required
                  />
                  <FormControl fullWidth>
                    <InputLabel>Método de venta</InputLabel>
                    <Select
                      value={lineaServicio}
                      onChange={(e) => setLineaServicio(e.target.value)}
                      required
                    >
                      {lineasDeServicio.map((linea, index) => (
                        <MenuItem key={index} value={linea.value}>
                          {linea.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div>Descripción del Formulario</div>
                  <textarea
                    label="Descripción del Formulario"
                    variant="outlined"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  />
                  <FormControl fullWidth>
                    <InputLabel>Canal</InputLabel>
                    <Select
                      value={canal}
                      onChange={(e) => setCanal(e.target.value)}
                      required
                    >
                      <MenuItem value="INSTAGRAM">Instagram</MenuItem>
                      <MenuItem value="LINKEDIN">LinkedIn</MenuItem>
                      <MenuItem value="FACEBOOK">Facebook</MenuItem>
                      <MenuItem value="EMAIL">Email</MenuItem>
                      <MenuItem value="WEB">Página Web</MenuItem>
                    </Select>
                  </FormControl>
                  <Button type="submit" variant="contained" color="primary">
                    Crear
                  </Button>
                </form>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormularioPrincipal;
